import * as React from 'react';

export const SlimCameraIcon = (props: React.SVGProps<SVGSVGElement>) => (
	<svg
		version="1.1"
		viewBox="0 0 1200 1200"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
		fill="currentColor"
	>
		<g fill="none" stroke="#059" strokeLinecap="round" strokeMiterlimit="10" strokeWidth="3">
			<path
				transform="scale(13.333)"
				d="m45.4 35.2c-5.9001 0-10.8 4.8-10.8 10.8 0 5.9001 4.8 10.8 10.8 10.8s10.8-4.8999 10.8-10.8c0-5.8998-4.8-10.8-10.8-10.8z"
			/>
			<path
				transform="scale(13.333)"
				d="m83.2 19.3h-18.7c-1.1001-6.0999-6.5001-10.8-12.9-10.8h-13.2c-6.3999 0-11.8 4.7001-12.9 10.8h-17.8c-2.6001 0-5.1999 2.0001-5.1999 4.5v48.3c0 2.4999 2.6001 4.8 5.1999 4.8h75.6c2.6001 0 4.2999-2.3001 4.2999-4.8v-48.3c-0.099902-2.4999-1.8-4.5-4.4001-4.5zm-37.8 46.4c-10.9 0-19.7-8.7999-19.7-19.7 0-10.9 8.7999-19.7 19.7-19.7 10.9 0 19.7 8.7999 19.7 19.7 0.099902 10.9-8.7999 19.7-19.7 19.7z"
			/>
		</g>
	</svg>
);
